import { render } from "./DigitalAccessTerms.vue?vue&type=template&id=e6c6d044"
import script from "./DigitalAccessTerms.vue?vue&type=script&lang=js"
export * from "./DigitalAccessTerms.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__